import React, { useState, useRef, useEffect } from "react";
import UserProfile from "../UserProfile/UserProfile";
import headerLogo from "../../images/header-logo.png";
import handleClick from "../../utils/handleClick.js";
import "./Header.css";
import TemplateMetadata from "../TemplateMetadata/TemplateMetadata.jsx";

const Header = ({
  handleUpdateUser,
  handleSignOut,
  scriptVersion,
  findButton,
  setFindButton,
}) => {
  const [showUserProfile, setShowUserProfile] = useState(false);
  const [showHash, setShowHash] = useState(false);
  const [showSearchInput, setShowSearchInput] = useState(false);
  const searchInputRef = useRef(null);
  const [isTemplateMetadataOpen, setIsTemplateMetadataOpen] = useState(false);

  const toggleUserProfile = () => {
    setShowUserProfile(!showUserProfile);
  };

  const toggleHashDisplay = () => {
    setShowHash(!showHash);
  };

  const toggleSearchInput = () => {
    setShowSearchInput((prev) => {
      if (prev) {
        setFindButton("");
      }
      return !prev;
    });
  };

  useEffect(() => {
    if (showSearchInput) {
      searchInputRef.current.focus();
    }
  }, [showSearchInput]);

  const handleLogoClick = (event) => {
    if (event.ctrlKey || event.metaKey) {
      window.jsx.evalScript(
        `new Folder(Folder.userData.fsName + "/Harchenko").execute();`,
      );
      return;
    }

    toggleHashDisplay();
  };

  return (
    <>
      <TemplateMetadata
        isOpen={isTemplateMetadataOpen}
        onClose={() => setIsTemplateMetadataOpen(false)}
      />
      <UserProfile
        isShown={showUserProfile}
        onClose={toggleUserProfile}
        handleUpdateUser={handleUpdateUser}
        handleSignOut={handleSignOut}
        scriptVersion={scriptVersion}
      />
      <div className="header">
        <div>
          <img
            src={headerLogo}
            className="header__logo"
            alt="logo"
            onClick={handleLogoClick}
          />
        </div>
        {showHash && <div className="header__hash">{scriptVersion || "dev"}</div>}
        <div className="header__controls">
          {/* <i
            className={`fa ${
              showSearchInput ? "fa-times" : "fa-magnifying-glass"
            } header__profile`}
            onClick={toggleSearchInput}
          ></i>
          {showSearchInput && (
            <input
              type="text"
              className="rename__input"
              ref={searchInputRef}
              value={findButton}
              onChange={(e) => setFindButton(e.target.value)}
            />
          )} */}
          <div className="header__user_group">
            {!showSearchInput && (
              <div
                className="header__profile"
                onClick={() => setIsTemplateMetadataOpen(true)}
                title="Template metadata"
              >
                <i class="fa-sharp fa-light fa-square-info"></i>
              </div>
            )}
            {!showSearchInput && (
              <div
                className="header__profile"
                onClick={() => handleClick("openTemplateFolder")}
              >
                <i class="fa-regular fa-folder-open"></i>
              </div>
            )}
            <div className="header__profile" onClick={toggleUserProfile}>
              <i className="fa-sharp fa-solid fa-bars"></i>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
